import React from 'react'

function Faq() {
  return (
    <>
    <h3 className='flex-left'><a href='https://stickeresteaua.vercel.app'>Go back</a></h3>
    <div className='flex-container'>
        <h1 >Intrebari frecvente</h1>
    </div>

        <div className='flex-left'>
            
        <h3>1. De unde pot sa cumpar stickere?</h3>
        <p>Nu vand stickere. Eu doar fac modelele si fiecare le printeaza pe cont propriu</p>
        <p>Am rugamintea ca nimeni sa nu vanda stickere cu modele aflate pe site</p>

        <br/>
        <br/>
        <br/>
        <br/>
        <h3>2. Unde pot sa printez stickere?</h3>
        <p>Depinde.</p>
        <p>Doresti stickere de calitate? Pt stickere de calitate care nu se rup, rezista la ploaie, rezista la zapada, nu se decoloreaza in timp recomand <a href='https://stickerrepublic.com' target='_blank'> https://stickerrepublic.com </a> <br/>Dezavantajul este pretul ridicat</p>
        <p>Doresti sa printezi o cantitate mare de stickere la un pret decent? Dupa ce ai descarcat modele dorite poti merge la orice xerox si sa le spui ca doresti <b>print pe hartie autocolanta</b>
        <br/>
        Dezavantajul acestor stickere este ca se vor decolora in timp si se pot rupe usor
         </p>
         <br/>
        <br/>
        <br/>
        <br/>
        <h3>3. Cum aranjez mai multe stickere pe o pagina A4?</h3>
        <ol>
  <li>Instalezi photoshop</li>
  <li>Descarci <b> <a target='_blank' href='https://stickeresteaua.vercel.app/templatea4.pdf'> acest</a> </b> template A4</li>
  <li>Deschizi template-ul in photoshop</li>
  <li>Asezi modelele <b>fara sa suprapui de partea rosie.</b> Orice se afla peste marginea rosie <b>NU</b> se va printa.</li>
  <li>Salvezi pdf-ul </li>
  <li>Mergi la orice xerox, le trimiti fisierul si le spui ca vrei sa printezi pe hartie autocolanta </li>
</ol>
<br/>
        <br/>
        <br/>
        <br/>
        <h3>4. Mai faci modele?</h3>
        <p>In momentul de fata, nu. Poate in viitor</p>
        </div>
    </>
  )
}

export default Faq